export default function workspaceProducerId(state) {
  const val = state.workspaceProducerId;
  return val && (typeof val === 'object' ? val.key : val);
}
